import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_cuur2wm6ik: FaireBrandEntity = {
  token: "b_cuur2wm6ik",
  type: "brand",
  name: "Broccoli",
  avatarUrl: "https://cdn.faire.com/fastly/bdb14b0aca50d2e5452ab5fb76996bf86d88e2d44d4d041b8fa7f6da74e34f5f.jpeg",
  bannerUrl: "https://cdn.faire.com/fastly/84affaa1e2a409907d9c0c8660c2d8a9174347ccb7354a4a8f84956d0abf5715.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/bdb14b0aca50d2e5452ab5fb76996bf86d88e2d44d4d041b8fa7f6da74e34f5f.jpeg",
  heroImageUrl: "https://cdn.faire.com/fastly/84affaa1e2a409907d9c0c8660c2d8a9174347ccb7354a4a8f84956d0abf5715.jpeg",
  location: "Portland, OR, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 185,
  isTopShop: true,
  isInsider: true,
  description: "Broccoli is a publisher of unusual delights. We create artful magazines, coffee table books, oracle decks, and an array of creative products designed to spark curiosity.  We're an independent, women-led team, known globally for our design-forward and thoughtful publications. Thank you for spending time in our universe! ",
  meta: {
    source: "api",
    importedAt: "2026-10-12T19:15:43.598Z",
    importedBy: "entity-db-cli"
  }
};
